import { Search, DownloadLink, Select, Modal, Input, DSInputType, Info } from 'components'
import { useNavigate, useLocation } from 'react-router-dom'
import { getListMaterialOrder } from 'services/product'
import { ColumnDivStyled, RowDivStyled, TitleCol, FieldWrapper, Divider } from './styles'
import {
  MaximumMaterialsLimit,
  OldModelSpreadsheetUrl,
  ModelSpreadsheetUrl
} from './constants'
import { postMaintainDraft } from 'services/draft'
import { RequestBodyMaintainDraft } from 'services/draft/interfaces'
import { useDispatch, useSelector } from 'store/store'
import { MaterialOrderResponse, setDefaultParams } from 'store/ProductContext'
import { useEffect, useRef, useState } from 'react'
import {
  getItems,
  setDraftBody,
  setMaterialSearch,
  setMaterialsLimitExceed
} from 'store/SalesOrderContext/salesOrderSlice'
import { useFormContext, Controller } from 'react-hook-form'
import { SalesOrderFieldsInterface } from 'container/SalesOrder/interfaces'
import { CustomBoolean, TypesValidations } from 'constants/enums'
import { usePermissions } from 'commons/customHooks/useAuth'
import { ActionPerm } from 'components/Structures/Header/constants'
import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import useDebounce from 'commons/customHooks/useDebounce'
import {
  decimalToString,
  handleDiscountInput
} from 'container/CreateOrder/components/TopSection/utils'
import { percentualValueMask } from 'commons/utils/mask'

type InsertProp = { user: string; hasUnsavedOVConfig: boolean; hasOrderNumber: boolean }
function Insert({ user, hasOrderNumber }: InsertProp) {
  const dispatch = useDispatch()
  const {
    draftBody,
    emptyData,
    secureRecords,
    records,
    materialSearch,
    loadingMaterials: loading,
    isInternationalOrder
  } = useSelector((state) => state.salesOrder)
  const { isYTRA, isHAVAConectaOrder } = useSelector(({ ov }) => ov)
  const { focusMaterialInsertInput } = useSelector((state) => state.structure)
  const { defaultParams } = useSelector((state) => state.products)
  const [searchValue, setSearchValue] = useState('')
  const [searchPage, setSearchPage] = useState<number>(0)
  const [modalMaterial, setModalMaterial] = useState<boolean>(false)
  const methods = useFormContext<SalesOrderFieldsInterface>()
  const { getValues, setValue, control, reset } = methods
  const { verifyPermission } = usePermissions()
  const searchRef = useRef<HTMLInputElement>(null)

  function shouldDisable(action: ActionPerm) {
    return !verifyPermission(SCREENS.ORDER, action) || loading
  }

  const materialLine = [
    { title: 'Em linha', value: TypesValidations.NO },
    { title: 'Fora de linha', value: TypesValidations.YES }
  ]
  const formProductPathFromDescription = (codigo: string) => {
    return codigo
      .toLocaleLowerCase()
      .replace('- ', '')
      .replace(/ /g, '-')
      .replace(/(\.|\/)/g, '')
  }
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const request = {
    cd_empr: draftBody?.cd_empr,
    cd_orgn_vend: draftBody?.cd_orgn_vend,
    cd_canl_dstb: draftBody?.cd_canl_dstb,
    cd_seto_atvd: draftBody?.cd_seto_atvd,
    cd_escr_vend: draftBody?.cd_escr_vend,
    cd_tipo_orde: getValues('cd_tipo_orde'),
    fl_matr_fora_linh: getValues('fl_matr_fora_linh'),
    fl_matr_2qua: TypesValidations.NO,
    nr_pedi_rasc: draftBody?.nr_pedi_rasc,
    fl_mto_prep: draftBody?.fl_mto_prep,
    dt_dsjd_pedi: draftBody?.dt_dsjd_pedi,
    nr_pagi: '0'
  }

  const requestProductPage = (material: MaterialOrderResponse) => {
    if (secureRecords?.length >= MaximumMaterialsLimit) {
      dispatch(setMaterialsLimitExceed(true))
    } else {
      const materialPath = formProductPathFromDescription(material.cd_matr)
      navigate(`${pathname}/${materialPath}`)
    }
  }

  const handleMaterialSearch = (inputValue: string, page: string) => {
    const returnApi: Promise<MaterialOrderResponse[]> = getListMaterialOrder({
      ...request,
      cd_matr: inputValue,
      qt_rowcount: 15,
      nr_pagi: page
    })

    return returnApi
  }

  useEffect(() => {
    setSearchValue(materialSearch)
  }, [materialSearch])
  const dispatchSearch = (value: string) => {
    dispatch(setMaterialSearch(value))
    dispatch(getItems('', value))
  }
  const debounceSearch = useDebounce(dispatchSearch, 1000)
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLocaleUpperCase()
    setSearchValue(value)
    debounceSearch(value)
  }

  const handleMaterialSelection = (e: MaterialOrderResponse) => {
    if (e.cd_cent_matr === null || !e.cd_cent_matr.trim()) {
      setModalMaterial(true)
      return
    }
    localStorage.setItem('material', JSON.stringify(e))

    const clie: Record<string, string> = getValues('cd_clie') as unknown as Record<
      string,
      string
    >

    const form = getValues()
    const {
      cd_seto_atvd,
      cd_tipo_orde,
      fl_mto_prep,
      pc_dsct,
      fl_prmt_desd,
      cd_cond_pgto,
      ds_cond_pgto,
      nr_pedi_clie,
      nr_dias_adic,
      address,
      cd_clie_entr,
      nr_pedi_rasc,
      dt_ano_mes_cota,
      dt_dsjd_pedi,
      ds_text_nota_fisc,
      fl_matr_fora_linh,
      ds_text_item_mto
    } = form

    const bodyMaintainRascunho: RequestBodyMaintainDraft = {
      ...draftBody,
      cd_clie: clie.cd_clie || '',
      cd_seto_atvd: cd_seto_atvd || '',
      nr_pedi_rasc: nr_pedi_rasc || '',
      cd_tipo_orde,
      nr_dias_adic,
      nr_pedi_clie,
      nr_pedi_cpra: '',
      cd_clie_entr: address || cd_clie_entr || '',
      ds_text_item_mto,
      fl_matr_fora_linh,
      fl_mto_prep,
      fl_dsct_matr: TypesValidations.YES,
      fl_prmt_desd,
      pc_dsct,
      ds_item_pedi_rasc: [],
      cd_usua_alte: user,
      cd_cond_pgto,
      ds_cond_pgto,
      dt_ano_mes_cota,
      dt_dsjd_pedi,
      ds_text_nota_fisc: ds_text_nota_fisc
    }
    reset(getValues())
    postMaintainDraft(bodyMaintainRascunho).then(() => {
      dispatch(
        setDraftBody({
          ...draftBody,
          cd_tipo_orde,
          nr_dias_adic,
          fl_prmt_desd: fl_prmt_desd as CustomBoolean,
          nr_pedi_clie,
          dt_ano_mes_cota,
          pc_dsct: pc_dsct ?? 0,
          cd_seto_atvd,
          ds_text_item_mto,
          fl_mto_prep,
          cd_cond_pgto,
          ds_cond_pgto: ds_cond_pgto ?? '',
          dt_dsjd_pedi,
          fl_matr_fora_linh: fl_matr_fora_linh as CustomBoolean,
          ds_text_nota_fisc: ds_text_nota_fisc
        })
      )

      dispatch(
        setDefaultParams({
          ...defaultParams,
          cd_matr: e.cd_matr,
          cd_tipo_orde: cd_tipo_orde,
          cd_cent_matr:
            draftBody.fl_pedi_antp === TypesValidations.YES
              ? ''
              : e.cd_cent_matr.split(',')[0],
          fl_matr_fora_linh: fl_matr_fora_linh as CustomBoolean
        })
      )
      requestProductPage(e)
    })
  }

  return (
    <ColumnDivStyled>
      <RowDivStyled>
        <TitleCol>
          <span id="MaterialsInsertTitle">Inserção de material</span>
          <span id="MaterialsInsertSubtitle">
            Após preencher o cabeçalho selecione, especifique e solicite os materiais
          </span>
        </TitleCol>

        <DownloadLink
          content="Baixar planilha modelo"
          options={[
            { label: 'Modelo Antigo (.xls)', url: OldModelSpreadsheetUrl },
            { label: 'Modelo Novo (.xlsx)', url: ModelSpreadsheetUrl }
          ]}
          disabled={isHAVAConectaOrder}
        />
      </RowDivStyled>

      {hasOrderNumber && (
        <>
          <Divider />
          <FieldWrapper
            templateColumns="130px 1.8fr 1.5fr 90px 1fr"
            mediaTemplateColumnsMD=".8fr 1.2fr 0 .5fr 1.22fr"
          >
            <Controller
              name="fl_matr_fora_linh"
              control={control}
              render={({ field }) => (
                <Select
                  label="Produção"
                  name={field.name}
                  value={field.value}
                  disabled={
                    loading ||
                    !!searchValue ||
                    !!records.length ||
                    draftBody.fl_pedi_antp === TypesValidations.YES ||
                    isHAVAConectaOrder
                  }
                  onChange={(value) => {
                    field.onChange(value)
                  }}
                  options={materialLine}
                />
              )}
            />
            <Search<MaterialOrderResponse>
              type="select"
              labelsConcat={['ds_matr', 'cd_matr']}
              label="Adicionar material"
              valueCase="upper"
              disabled={shouldDisable(ACTIONS_SCREENS.EDIT) || isHAVAConectaOrder}
              minimumInput={3}
              optionsMaxHeight="300px"
              optionsLimit={15}
              loadOptions={handleMaterialSearch}
              clearAfterSelect
              setOptionSelected={handleMaterialSelection}
              buttonSelectOption={false}
              keysColumnsOption={['ds_matr']}
              titlesColumnsOption={[]}
              columnsSizeOption={['100%']}
              flexWrapRowOption
              flexWrapOptionDescription={false}
              placeHolder="Busque por código ou nome"
              setPage={setSearchPage}
              page={searchPage}
              shouldFocusInput={focusMaterialInsertInput}
            />
            <span></span>
            <div>
              <Controller
                name="pc_dsct"
                control={control}
                render={({ field: { name, value, onChange }, fieldState: { error } }) => (
                  <Input
                    design={DSInputType.PERCENT_INPUT}
                    label="Desconto"
                    id="discount"
                    name={name}
                    value={decimalToString(value as number)}
                    addorment
                    maxLength={5}
                    disabled={
                      draftBody.totalizador.qt_tota_item_soli > 0 ||
                      isYTRA ||
                      isInternationalOrder
                    }
                    errorOutline={!!error?.message}
                    onChange={(e) => {
                      onChange(percentualValueMask(e.target.value))
                    }}
                    onBlur={(e) => {
                      const currentValue = getValues('pc_dsct') as unknown as number
                      const pc_dsct = handleDiscountInput(e.target.value, currentValue)
                      setValue('pc_dsct', pc_dsct)
                      setValue('fl_dsct_matr', 'S')
                    }}
                    InputProps={{
                      fullWidth: true,
                      inputProps: { maxLength: 5 }
                    }}
                    labelAdornment={
                      <Info iconSize={12}>
                        Este campo fará com que o desconto especificado seja aplicado a
                        todos os materiais adicionados no pedido, porém não impede
                        alterações posteriores feitas em itens específicos.
                      </Info>
                    }
                  />
                )}
              />
            </div>
            <span>
              <Input
                addorment
                label="Localizar material"
                design={DSInputType.SEARCH_INPUT}
                value={searchValue}
                onChange={handleSearch}
                InputProps={{ placeholder: 'Busque por código' }}
                disabled={!materialSearch && emptyData}
                ref={searchRef}
              />
            </span>
          </FieldWrapper>
        </>
      )}

      <Modal
        open={modalMaterial}
        setOpen={setModalMaterial}
        title="Material indisponível"
        description="A venda deste produto foi interrompida, consulte o back office para mais informações"
        buttonText="Entendi"
      />
    </ColumnDivStyled>
  )
}

export default Insert
